// frontend/src/features/auth/Login.js
// This React page renders the login form, dispatches the auth thunk to sign in, shows errors/loading, and redirects users to the correct dashboard based on their role after successful login.
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import { login } from './authSlice';

export default function Login() {
  const dispatch = useDispatch();
  const navigate  = useNavigate();
  const { userInfo, loading, error } = useSelector(state => state.auth);

  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');

  // As soon as userInfo changes (i.e. login succeeded), redirect appropriately:
  useEffect(() => {
    if (userInfo) {
      if (userInfo.role.startsWith('ups_')) {
        navigate('/ups/dashboard');
      } else {
        navigate('/agencies/dashboard');
      }
    }
  }, [userInfo, navigate]);

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      // dispatch returns the user object, which the slice puts into userInfo
      await dispatch(login({ email, password })).unwrap();
      // no need to navigate here; the useEffect will fire on userInfo
    } catch (err) {
      console.error('Login failed:', err);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8">
        <h2 className="text-2xl font-bold text-center mb-6">Sign In</h2>

        {error && (
          <div className="mb-4 text-sm text-red-700 bg-red-100 p-3 rounded">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label htmlFor="email" className="block text-gray-700 mb-2">
              Email Address
            </label>
            <input
              id="email"
              type="email"
              required
              value={email}
              onChange={e => setEmail(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-primary"
              placeholder="you@example.com"
            />
          </div>

          <div>
            <label htmlFor="password" className="block text-gray-700 mb-2">
              Password
            </label>
            <input
              id="password"
              type="password"
              required
              value={password}
              onChange={e => setPassword(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-primary"
              placeholder="••••••••"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full py-2 bg-primary text-white rounded hover:bg-primary/90 transition"
          >
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>

        <div className="mt-6 text-center text-sm text-gray-600">
          <Link
            to="/forgot-password"
            className="text-primary font-medium hover:underline"
          >
            Forgot your password?
          </Link>
        </div>
      </div>
    </div>
  );
}
